import axios, { CancelToken } from 'axios';
import { withTimeout } from './withTimeout';

export const MISSION_READ_TIMEOUT_MS = 20_000;

/** A query owns its cancellation token; cancelling it cannot poison another query. */
export const readMissions = async <T,>(
  request: (token: CancelToken) => Promise<T>,
  signal?: AbortSignal,
): Promise<T> => {
  const source = axios.CancelToken.source();
  const cancel = () => source.cancel('Mission query cancelled');
  signal?.addEventListener('abort', cancel, { once: true });
  try {
    if (signal?.aborted) {
      cancel();
      source.token.throwIfRequested();
    }
    return await withTimeout(request(source.token), MISSION_READ_TIMEOUT_MS, cancel);
  } finally {
    signal?.removeEventListener('abort', cancel);
  }
};
